import { useEffect, useState, useRef } from "react"
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import authAxios from "../../components/authAxios";

import { IconButton } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import DescriptionIcon from '@mui/icons-material/Description';
import Tooltip from '@mui/material/Tooltip';



//TABS - BOOTSTRAP
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';


import { Dropdown, Menu, Space } from 'antd';

import DashboardHeader from "../../components/DashboardHeader";
import UserAlerts from "../../components/UserAlerts";
import RepaymentSchedule from "./RepaymentSchedule";
import LoanComponents from "./LoanComponents";

const Loan = () => {
    const params = useParams()
    const navigate = useNavigate()
    const [error, setError] = useState('');
    const errorRef = useRef(null);

    // const propertyId = params.id
    const loanId = params.id

    const removeBorder = true
    // const [page, setPage] = useState(1);
    // const [pagecount, setPageCount] = useState();

    const { data: clientProfile } = useQuery({
        queryKey: ['clientProfile'],
        queryFn: async () => {
          const response = await authAxios.get(`/clientprofiles/${localStorage.getItem('clientProfile')}`);
          return response.data

        },
    });

    const { data: loan } = useQuery({
        queryKey: ['loan',loanId],
        queryFn: async () => {
          const response = await authAxios.get(`loans/loans/${loanId}`);
          return response.data
        },
    });

   
    const menu = (
        <Menu>
            <Menu.Item disabled>
                <a target="_blank" rel="noopener noreferrer" href="https://www.luohanacademy.com">
                    Other Items
                </a>
            </Menu.Item>
        </Menu>
    );
        

    //Bootstrap Tabs
    const [key, setKey] = useState('schedule');
    const handleTabChange = (k) => {
        setKey(k)
    };


    const LoanSummaryData = () => {
        return(
        <div className="dashboard-content-subheader">
            <div className='dashboard-card'>
                <div className="dashboard-card-pretitle">
                    Principal
                </div>
                <div className="dashboard-card-text">
                    {/* {clientProfile.currency_code} {property.total_revenue.toLocaleString()} */}
                    {Number(loan.amount).toLocaleString()}
                </div>
            </div>
            <div className='dashboard-card'>
                <div className="dashboard-card-pretitle">
                    Interest
                </div>
                <div className="dashboard-card-text">
                    {Number(loan.total_interest).toLocaleString()}

                </div>
            </div>
            <div className='dashboard-card'>
                <div className="dashboard-card-pretitle">
                    Charges
                </div>
                <div className="dashboard-card-text">
                    {Number(loan.total_charges).toLocaleString()}
                </div>
            </div>
            <div className='dashboard-card'>
                <div className="dashboard-card-pretitle">
                    Paid
                </div>
                <div className="dashboard-card-text">
                    {Number(loan.total_paid).toLocaleString()}
                </div>
            </div>
            <div className='dashboard-card'>
                <div className="dashboard-card-pretitle">
                    Outstanding
                </div>
                <div className="dashboard-card-text">
                    {Number(loan.outstanding_loan).toLocaleString()}
                </div>
            </div>

        </div>
        )
    }

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])

    return (
        <div className="dashboard-main">
            {loan &&

            <section className="dashboard-content dashboard-content-compact">
                 <div ref={errorRef}>
                    <UserAlerts error={error} />
                </div>

                <div className="dashboard-content-header-nav">
                    <DashboardHeader dashboardTitle={loan.customer_name} dashboardPreTitle="Loan" removeBorder={removeBorder} />

                    <div className="dashboard-content-header-nav-icons">
                       
                        <Dropdown overlay={menu} placement="bottomRight" arrow>
                            <a onClick={e => e.preventDefault()}>
                            <Space>
                                <IconButton 
                                > 
                                    <MenuIcon />

                                </IconButton>

                            </Space>
                            </a>
                        </Dropdown>
                    </div>
                </div>


              
                <Tabs
                    activeKey={key}
                    onSelect={(k) => handleTabChange(k)}
                    className="dashboard-tabs"
                    id="property-tabs"
                    mountOnEnter={true}
                    unmountOnExit={true}
                    transition={false}
                    >

                    
                    <Tab eventKey="profile" title="Profile" disabled>
                        {/* <PropertyView 
                            property={property}
                            setError={setError}
                        /> */}
                    </Tab> 


                    <Tab eventKey="schedule" title="Schedule">
                        <LoanSummaryData />
            
                        <RepaymentSchedule 
                            loan={loan} 
                        />
                  
                    </Tab>
                    <Tab eventKey="charges" title="Charges">
                        <LoanSummaryData />

                        <LoanComponents 
                            loan={loan} 
                        />
                    </Tab> 


                </Tabs> 

            </section>
            }

        </div>
    );
  };
  
  export default Loan;